<template>
  <QuesCard :maxwidth="maxwidth" :ques="ques">
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}星級評分題
    </template>
    <v-card-text slot="content" class="text-start">
      <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx" class="blod quest_topic">{{ name }}</div>
      <div v-if="ques.questHeadingPic" class="text-center">
        <img
          v-bind:src="$store.state.server + ques.questHeadingPic"
          style="max-width: 100%;"
        />
      </div>

      <v-rating
        v-model="ques.value"
        :length="ques.length"
        :align="'center'"
        :justify="'center'"
        class="mb-3"
        x-large
        :dense="$vuetify.breakpoint.mobile"
      ></v-rating>
      <v-input
        :value="ques.value"
        :rules="[
          v => {
            let pass = !(ques.isRequired && !ques.value)
            return pass ? true : '此題為必填'
          }
        ]"
      >
      </v-input>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard
  },
  props: {
    maxwidth: {
      type: Number,
      default: null
    },
    ques: {
      type: Object,
      default: null
    }
  }
}
</script>

<style lang="scss" scoped></style>
